import { jsx as _jsx } from "react/jsx-runtime";
import NoTableData from './NoTableData';
export default function NoDataForFid() {
    return _jsx(NoTableData, { text: "Not available for FID" });
}
